(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Media-with-text"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionId = '{{ section.id }}';
  const animationSpeed = '{{ section.settings.animation_speed }}';
  
  // 设置动画持续时间
  let duration = 0.8;
  if (animationSpeed === 'slow') {
    duration = 1.2;
  } else if (animationSpeed === 'fast') {
    duration = 0.5;
  }
  
  // 初始化GSAP动画
  const section = document.getElementById(`media-text-section-${sectionId}`);
  if (!section) return;
  
  // 创建滚动触发器
  gsap.registerPlugin(ScrollTrigger);
  
  // 图标淡入动画
  const icon = section.querySelector('.img2');
  gsap.set(icon, { opacity: 0 });
  gsap.to(icon, {
    opacity: 1,
    duration: duration,
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });
  
  // 背景图片淡入动画
  const bgImage = section.querySelector('.img1');
  gsap.set(bgImage, { opacity: 0, scale: 1.05 });
  gsap.to(bgImage, {
    opacity: 1,
    scale: 1,
    duration: duration * 1.5,
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });
  
  // 文本滑入动画
  const textElements = section.querySelectorAll('.gsap-slide-up');
  gsap.set(textElements, { y: 30, opacity: 0 });
  
  textElements.forEach((element, index) => {
    gsap.to(element, {
      y: 0,
      opacity: 1,
      duration: duration,
      delay: 0.2 * index,
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none"
      }
    });
  });
  
  // 分隔线缩放动画
  const splitLine = section.querySelector('.split-line');
  gsap.set(splitLine, { scaleX: 0 });
  gsap.to(splitLine, {
    scaleX: 1,
    duration: duration,
    delay: 0.3,
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
